export enum PopUpActions {
	Cancel = 0,
	Ok = 1
}